import React from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import ContentCard from '../right-panel/content-card';
import { getAssetURL } from './style-pack';
import { ContentTemplate, StylePackContentType, StylePackItemTypes } from '../types/stylepacks';

export interface StylePackItemProps {
	item: ContentTemplate;
	type: string;
	skeletonSize?: {width:number, height:number, style?: React.CSSProperties}
}

export default function StylePackItem(props: StylePackItemProps) {
	const { item, type, skeletonSize } = props;

	return (
		<div
			className={classNames(
				`style-pack-${type}-content-item`,
				{
					'extra-padding': type === StylePackItemTypes.Info && item.contentType === StylePackContentType.TITLE,
				},
			)}
			data-testid={`style-pack-${type}-content-item-${item.id}`}
			id={`style-pack-${type}-content-item-${item.id}`}
			key={`style-pack-${type}-content-item-${item.id}`}
			style={skeletonSize && {
				minHeight: skeletonSize.height,
				minWidth: skeletonSize.width,
				maxHeight: skeletonSize.height,
				maxWidth: skeletonSize.width
			}}
		>
			{item?.videoUrl && (
				<ContentCard
					key={`style-pack-${type}-content-card-${item.id}`}
					url={getAssetURL(item?.videoUrl ?? '')}
					thumbnail={getAssetURL(item?.thumbnailUrl ?? item.data?.thumbnail?.url ?? '')}
					altText={item?.name || ''}
					slug={item?.type || ''}
					skeletonWidthHeight={skeletonSize}
					provider={item?.provider || ''}
					contentType={item?.contentType}
					contentTemplate={item}
				/>
			)}
			{!item?.videoUrl && (
				<div
					key={`style-pack-${type}-image-${item.id}`}
					className={`style-pack-${type}-image`}
					data-testid={`style-pack-${type}-image-${item.id}`}
					style={{
						backgroundImage: `url(${getAssetURL(item?.thumbnailUrl ?? item.data?.thumbnail?.url ?? '')}`,
						backgroundSize: 'cover',
						width: type === StylePackItemTypes.Info ? '376px' : '100%',
						height: type === StylePackItemTypes.Info ? '211px' : '100%',
					}}
				/>
			)}
			{!!item.locked && (
				<div
					className={`style-pack-${type}-lock-icon`}
					data-testid={`style-pack-${type}-lock-icon-${item.id}`}
				>
					<Icon
						name={ICONS.LOCK}
						color={COLORS.WHITE}
						size={16}
					/>
				</div>
			)}
		</div>
	);
}
